import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconPlantbasedProduct = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-4.712 8.555a.5.5 0 0 1 .65.28l1.73 4.337a.5.5 0 0 1-.93.37l-1.73-4.337a.5.5 0 0 1 .28-.65m-3.818 3.947a.5.5 0 0 1 .706.044l2.235 2.53a.5.5 0 0 1-.75.662l-2.235-2.53a.5.5 0 0 1 .044-.706m1.257 24.917c-.361.58-.706 1.196-1.023 1.83a.5.5 0 0 1-.671.224.5.5 0 0 1-.224-.67c.332-.664.691-1.307 1.07-1.913a.5.5 0 0 1 .848.53m18.368-7.41c-.431 1.24-1.025 2.428-1.803 3.488-1.59 2.165-3.907 3.659-6.503 4.314-2.943.743-6.313.506-9.095-.79a.51.51 0 0 1-.19-.752 17.5 17.5 0 0 1 1.57-1.895q.588-.61 1.186-1.22c4.425-4.535 9-9.225 9-17.687a.5.5 0 1 0-1 0c0 8.055-4.43 12.596-8.715 16.988q-.6.614-1.191 1.227a18.6 18.6 0 0 0-1.768 2.157.5.5 0 0 1-.696.13c-1.717-1.243-3.05-2.977-3.747-5.002a9.7 9.7 0 0 1-.254-5.44c.481-1.968 1.578-3.736 3.02-5.146 4.328-4.233 10.309-5.842 12.838-11.104.483-1.006 1.888-1.062 2.472-.11 2.648 4.32 7.403 13.56 4.876 20.842m3.91-6.82-.064-.004-1.455-.186a.5.5 0 0 1 .127-.992l1.455.185a.5.5 0 0 1-.063.996m.245-3.06-1.858.814a.5.5 0 1 1-.402-.916l1.858-.815a.501.501 0 0 1 .402.916',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconPlantbasedProduct)
export default ForwardRef
